/*Check if is mobile device*/
function isMobile(a) {
    return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)));
}
/*Check if value isEmpty */
function isEmpty(value) {
    return typeof value == 'string' && !value.trim() || typeof value == 'undefined' || value === null;
}


function detectIE() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        return true;
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        var rv = ua.indexOf('rv:');
        return true;
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
        return true;
    }

    // other browser
    return false;
}


/*Fix for BS modal issue*/
if (isMobile(navigator.userAgent || navigator.vendor || window.opera)) {

    var $contentModalScroll = new IScroll('#contentModal', {
        mouseWheel: true,
        scrollbars: false,
        click: true,
        bounce: false,
    });

    var $contactModalScroll = new IScroll('#contactModal', {
        mouseWheel: true,
        scrollbars: false,
        click: true,
        bounce: false,
    });
}

(function ($) {
    $(function () {
        var $contentModal = $('#contentModal .modal-body');

        if (detectIE()) {
            $('body').addClass('ie');
        }

        if ($(".page-template-page-products").length) {
            var hash = window.location.hash;

            if (hash) {
                setTimeout(function () {
                    var href = hash;
                    var navHeight = $('.navbar').outerHeight();
                    $('body,html').animate({
                        scrollTop: $(href).offset().top - navHeight
                    }, 1000, function () {
                        window.location.hash = href;
                    });
                    $(hash + ' .js-open-category').trigger('click');
                    return false;
                }, 1000);
            }
        }

        /*Match height*/
        if ($('.managers .picture-infos').length) {
            $('.managers .picture-infos').matchHeight({});
        }

        if ($('.others-slider .picture-infos').length) {
            $('.others-slider .picture-infos').matchHeight({});
        }

        if ($('.related-news .picture-infos').length) {
            $('.related-news .picture-infos').matchHeight({});
        }

        if ($('.manager-description').length) {
            $('.manager-description').matchHeight({});
        }

        if ($('.my-gallery-img').length) {
            $('.my-gallery-img img').matchHeight({});
        }

        if ($('.featured-products-slider-wrapper').length) {
            $('.featured-products-slider-wrapper .product-description').matchHeight({});
            $('.featured-products-slider-wrapper .product-category .category-title span').matchHeight({});
        }

        $('.main-menu-cat').on('click', function () {
            $(this).find('.plus-icon').toggleClass('active');
            $(this).find('.sub-menu').slideToggle(500);
        });

        var $grid = $('.products-container').packery({
            itemSelector: '.product-item',
            columnWidth: '.product-item',
        });

        //  $('.my-gallery').packery({
        //     itemSelector: '.my-gallery-img',
        //     columnWidth: '.my-gallery-img',
        // });

        $('.js-open-category').on('click', function () {
            $(this).parent().parent().toggleClass('active');
            $(this).parent().find('.plus-icon').toggleClass('active');
            $(this).parent().find('.products-list').slideToggle(500, function () {
                $grid.packery('shiftLayout');
            });

        });

        /*Prevent body jumping when modal shown*/
        $('.modal').on('show.bs.modal', function (e) {
            $('body').addClass('no-jump');
            $('header').hide();
        });

        $('.modal').on('hide.bs.modal', function (e) {
            $('header').show();
        });



        /*        function reposition() {
                    var modal = $(this),
                        dialog = modal.find('.modal-dialog');
                    modal.css('display', 'block');
                    dialog.css("margin-top", Math.max(0, ($(window).height() - dialog.height()) / 2));
                }

                $('.modal').on('show.bs.modal', reposition);

                $(window).on('resize', function() {
                    $('.modal:visible').each(reposition);
                });*/

        $('.js-open-picture').on('click', function () {
            var $img = $(this).data('img');
            $contentModal.empty();
            $contentModal.append('<div class="manager-img-mobil dark-bg"><img src="' + $img + '" class="img-responsive" alt=""></div>');

            if (!isEmpty($contentModalScroll)) {
                $contentModalScroll.refresh();
            }


            $('#contentModal').modal('show');
        });

        $('.js-open-picture-content-box').on('click', function () {
            var $img = $(this).data('img');
            $contentModal.empty();
            $contentModal.append('<div class="modal-image"><img src="' + $img + '" class="img-responsive" alt=""></div>');
            if (!isEmpty($contentModalScroll)) {
                $contentModalScroll.refresh();
            }
            $('#contentModal').modal('show');
        });


        /*Scroll to top*/
        $('.back-to-top').on('click', function () {
            var body = $("body, html");
            body.animate({ scrollTop: 0 }, '500');
        })

        $(window).on("scroll", function () {
            var scrollPos = $(window).scrollTop();
            if (scrollPos <= 0) {
                $('.back-to-top').fadeOut('200');
            } else {
                $('.back-to-top').fadeIn('400');
            }
        });

        /*Blur image on scroll*/
        $(window).on('scroll', function () {
            pxlCount = $(document).scrollTop() / 2;
            if ($('body').hasClass('single-post')) {
                $(".headline-bg").css({ "-webkit-filter": "grayscale(" + pxlCount + "%) blur(4px)", "-moz-filter": "grayscale(" + pxlCount + "%) blur(4px)", "filter": "grayscale(" + pxlCount + "%) blur(4px)" });
            } else {
                $(".headline-bg").css({ "-webkit-filter": "grayscale(" + pxlCount + "%)", "-moz-filter": "grayscale(" + pxlCount + "%)", "filter": "grayscale(" + pxlCount + "%)" });
            }
        });


        /*Cookie Policy*/
        function cookiesPolicyBar() {
            // Check cookie
            if (Cookies.get('cookiepolicy') != "active") $('#cookieAcceptBar').show();
            //Assign cookie on click
            $('#cookieAcceptBarConfirm').on('click', function () {
                Cookies.set('cookiepolicy', 'active', { expires: 31, path: '/' });
                $('#cookieAcceptBar').fadeOut();
            });
        }

        cookiesPolicyBar();

        $('.js-get-details').on('click', function (e) {
            e.preventDefault();

            var post_id = $(this).data('id');

            $.ajax({
                type: "post",
                context: this,
                dataType: "json",
                url: delizia_localize.ajaxurl,
                data: {
                    action: "get_details",
                    post_id: post_id,
                },
                beforeSend: function (data) {
                    $contentModal.empty();
                    $contentModal.append('<div class="preloader" style="text-align:center;"><img  src="' + delizia_localize.themeurl + '/assets/img/preloader.gif" alt="Delizia Preloader"></div>')
                    $('#contentModal .modal-footer').hide();
                    $('#contentModal').modal('show');
                },
                success: function (response) {
                    var $style = '';
                    if (response['img']['placeholder'] == true) {
                        $style = ' style="background-color: #212121;"';
                    }
                    $contentModal.empty();
                    $contentModal.append('<div class="row first-row"><div class="col-md-6 modal-left"><div class="modal-picture"' + $style + '><img src="' + response['img']['url'] + '" class="img-responsive" alt="' + response['img']['alt'] + '"></div></div><div class="col-md-6 modal-right"><h1 class="modal-category-title">' + response['title'] + '</h1></div></div><div class="row second-row"><div class="col-xs-12">' + response['content'] + '</div></div>');
                    $('#contentModal .modal-footer').show();
                    if (!isEmpty($contentModalScroll)) {
                        $contentModalScroll.refresh();
                    }
                }
            });
        });

        /* Popup modal */
        if ($('#popupmodal').length) {

            var popupCookie = Cookies.get('page_popup');
            //popupCookie = undefined; //Show always
            if (popupCookie == undefined) {

                $('#popupmodal').modal('show');

                var x = Math.floor((Math.random() * 1000) + 1);
                Cookies.set('page_popup', x, { expires: 3 });
                
                if (isMobile(navigator.userAgent || navigator.vendor || window.opera)) {
                    $('#popupmodal').on('shown.bs.modal', function (e) {
                        new IScroll('#popupmodal', {
                            mouseWheel: true,
                            scrollbars: false,
                            click: true,
                            bounce: false,
                        });

                    })
                }
            }

        } else {
            Cookies.remove('page_popup');
        }


        $('.js-open-webshop-modal a').on('click',function(e){
            e.preventDefault()

            $('#webshop_popupmodal').modal('show');

        
            if (isMobile(navigator.userAgent || navigator.vendor || window.opera)) {
                $('#webshop_popupmodal').on('shown.bs.modal', function (e) {
                    new IScroll('#webshop_popupmodal', {
                        mouseWheel: true,
                        scrollbars: false,
                        click: true,
                        bounce: false,
                    });

                })
            }
        })


    });
})(jQuery);